module.exports = __webpack_public_path__ + "static/tutorial1-1120ce1b0443de60a909f5d72f61e827.png";